import React from "react";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { GenCCType } from "../../../../components/componentTypes/GenCCType";
import GenCCContent from "./GenCCContent";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import HelperText from "../../../../components/atoms/HelperText";

const GenCC = ({ data }) => {
  if (!data || !data?.items || data?.items?.length === 0) return null;
  return (
    <div className="varsome-result-fixed" data-testid="gencc-component">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="GenCC"
          version={data?.version}
          url={getVarsoUrl("https://search.thegencc.org/")}
          helperPopup={<HelperText fieldDescriptionKey="GenCC" />}
          content={
            <div className="varsome-inner-container">
              {data?.items && <GenCCContent items={data?.items} />}
            </div>
          }
        />
      </div>
    </div>
  );
};

GenCC.propTypes = {
  data: GenCCType,
};

GenCC.defaultProps = {
  data: null,
};

export default withErrorGuard(GenCC, "GenCC", "GenCC");
